type CaretIconProps = {
  className?: string;
};

export default ({ className }: CaretIconProps) => (
  <svg width="43" height="44" viewBox="0 0 43 44" fill="none" className={className}>
    <path d="M12.3819 6.16664L39.4543 21.7969L12.3819 37.4271L12.3819 6.16664Z" stroke-width="3.35781" />
  </svg>
);
